var _path, _circle;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgArrow(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 117,
    height: 117,
    fill: "none",
    viewBox: "0 0 117 117",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FEE9BE",
    d: "M26 55L23 55L23 61L26 61L26 55ZM92 58L92.9235 60.8543L92.53 55.0472L92 58ZM26 61L92 61L92 55L26 55L26 61ZM92.53 55.0472C83.9725 53.5112 77.9682 47.4483 74.012 40.8349C72.0487 37.5529 70.6516 34.2304 69.7497 31.4735C68.8166 28.6209 68.5 26.641 68.5 26L62.5 26C62.5 27.609 63.0584 30.3166 64.0471 33.339C65.0671 36.4571 66.6388 40.1971 68.863 43.9151C73.2818 51.3017 80.5275 58.9888 91.47 60.9528L92.53 55.0472ZM91.0765 55.1457C81.7528 58.1622 74.6419 64.9518 69.9008 71.8659C65.2226 78.6883 62.5 86.1575 62.5 91L68.5 91C68.5 87.8425 70.5274 81.5617 74.8492 75.2591C79.1081 69.0482 85.2472 63.3378 92.9235 60.8543L91.0765 55.1457Z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 58.5,
    cy: 58.5,
    r: 57.5,
    stroke: "#FEE9BE",
    strokeWidth: 2,
    transform: "rotate(-90 58.5 58.5)"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow);
export default __webpack_public_path__ + "static/media/arrow.14c17006db5a4a08fd83c02def65b183.svg";
export { ForwardRef as ReactComponent };